import reducer from "./reducer";
export { default as CommunicationChannel } from "./components/index";
export { default as communicationChannelReducerName } from "./constants";
export default reducer;
